module.exports = __webpack_public_path__ + "img/lg_ring_y_e_1_null@3x.a09c5702.png";